import { cn } from '../../../../lib/utils';

interface StatCardProps { label: string; value: string; sub?: string; color?: string }
interface BadgeProps { label: string; type: 'good' | 'fair' | 'poor' }

export function StatCard({ label, value, sub, color }: StatCardProps) {
  return (
    <div className="rounded-xl border border-border bg-card px-4 py-3.5">
      <div className="mb-1.5 text-[12px] font-semibold uppercase tracking-[0.04em] text-muted-foreground">
        {label}
      </div>
      <div
        className="text-heading-h5 text-foreground"
        style={{ color }}
      >
        {value}
      </div>
      {sub && <div className="mt-1 text-caption-regular text-muted-foreground">{sub}</div>}
    </div>
  );
}

const BADGE_CLASSES: Record<BadgeProps['type'], string> = {
  good: 'bg-emerald-50 text-emerald-700',
  fair: 'bg-yellow-50 text-yellow-700',
  poor: 'bg-rose-50 text-rose-700',
};

export function Badge({ label, type }: BadgeProps) {
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-[11px]/4 font-medium', BADGE_CLASSES[type])}>
      {label}
    </span>
  );
}

export function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <h3 className="mb-3.5 flex items-center gap-2 text-body-md-medium text-foreground">
      {children}
    </h3>
  );
}
